export default {"src":"/blog/_next/static/media/twitter.de422a71.svg","height":13,"width":15};